import request from '@/utils/request'

export function getTrainingList(params) { // 培训列表
    return request({
        url: '/api/trainings/' ,
        method: 'get',
        params
    })
}
export function getTrainingDtl(params) { // 培训详情
    return request({
        url: '/api/trainings/' + params.id +'/',
        method: 'get',
    })
}
export function updateTraining(data) { // 修改培训
    return request({
        url: '/api/trainings/' + data.id +'/',
        method: 'put',
        data:data.data
    })
}

export function saveTraining(data) {  // 新增培训的保存
    return request({
        url: '/api/trainings/',
        method: 'post',
        data
    })
}
export function deleteTraining(params) {  // 删除培训
    console.log('params===',params)
    return request({
        url: '/api/trainings/' +params.id+'/',
        method: 'delete',
    })
}
export function chooseTrainer(params) { // 选择参训人员
    return request({
        url: '/api/user_by_org/' ,
        method: 'get',
        params
    })
}
export function getParticipantsDtl(params) { // 培训查看学习情况详情
    return request({
        url: '/api/participants_detail/',
        method: 'get',
        params
    })
}

export function addParticipants(data) {  // 新增培训人员
    return request({
        url: '/api/add_participants/',
        method: 'post',
        data
    })
}
// 考试

export function getExamList(params) { // 考试列表
    return request({
        url: '/api/exams/' ,
        method: 'get',
        params
    })
}

export function saveExam(data) {  // 新增考试
    return request({
        url: '/api/exams/',
        method: 'post',
        data
    })
}
export function getTrainOptions(params) { //新增考试关联的培训
    return request({
        url: '/api/trainings_for_all/' ,
        method: 'get',
        params
    })
}
export function getExamDtl(params) { // 考试详情
    return request({
        url: '/api/exams/' + params.id +'/',
        method: 'get',
    })
}
export function updateExams(data) { // 编辑考试
    return request({
        url: '/api/exams/' + data.id +'/',
        method: 'put',
        data:data.data
    })
}
export function deleteExam(params) {  // 删除考试
    return request({
        url: '/api/exams/' +params.id+'/',
        method: 'delete',
    })
}
export function getExamQuestions(params) { // 获取某个考试下已选择的题目
    return request({
        url: '/api/exam_questions/' ,
        method: 'get',
        params
    })
}
export function saveExamQuestions(data) {  // 保存/更新,某个考试下已选择的题目
    return request({
        url: '/api/exam_questions/',
        method: 'post',
        data
    })
}

export function getExamRule(params) { // 查看考试规则--分值/题量设置详情获取
    return request({
        url: '/api/exam_rule/' ,
        method: 'get',
        params
    })
}

export function saveExamRule(data) {  // 新增考试规则
    return request({
        url: '/api/exam_rule/',
        method: 'post',
        data
    })
}
export function updateExamRule(data) { // 更新考试规则
    return request({
        url: '/api/exam_rule/batch_update/',
        method: 'put',
        data: data
    })
}
export function getQuetionRepositories(params) { // 获取可选题库列表
    return request({
        url: '/api/repositories_for_all/' ,
        method: 'get',
        params
    })
}
export function getQuetionList(params) { //选中某个题库后获取对应的题目
    return request({
        url: '/api/questions/' ,
        method: 'get',
        params
    })
}
export function getExamUserDtl(params) { //查看考试情况-列表数据
    return request({
        url: '/api/exam/users/detail/' ,
        method: 'get',
        params
    })
}
export function checkSubmitAnswers(params) { //查看考试答题记录情况
    return request({
        url: '/api/check_submit_answers/' ,
        method: 'get',
        params
    })
}

// 题库
export function getRepositoryList(params) { // 获取题库列表
    return request({
        url: '/api/repository/list/' ,
        method: 'get',
        params
    })
}

export function deleteQuestionBank(data) {  // 删除某一道题目
    return request({
        url: '/api/repository/delete/',
        method: 'DELETE',
        data
    })
}
export function getRepositoryDtl(params) { // 获取题库详情
    return request({
        url: '/api/repository/detail/' + params.id +'/',
        method: 'get',
    })
}
export function getRepositoryDtlTable(params) { // 获取考试详情对应的列表
    return request({
        url: '/api/questions/' ,
        method: 'get',
        params
    })
}

export function saveQuestions(data) {  // 保存/更新,某个考试下已选择的题目
    return request({
        url: '/api/questions/',
        method: 'post',
        data
    })
}

export function getQuestDtl(params) { // 获取题目详情列表
    return request({
        url: '/api/questions/' + params.id +'/' ,
        method: 'get',
        params
    })
}
export function updateQuestions(data) { // 更新一道题目
    return request({
        url: '/api/questions/' + data.id +'/',
        method: 'put',
        data:data.data
    })
}
export function deleteQuestions(data) {  // 删除某一道题目
    return request({
        url: '/api/questions/' + data.id +'/',
        method: 'DELETE',

    })
}
// 更新题库
export function updateQuestionsRepository(data) {  // 更新题库
    return request({
        url: '/api/repository/update/',
        method: 'put',
        data
    })
}
export function saveQuestionsBatchCreate(data) {  // 新增题库，批量新增题目
    return request({
        url: '/api/repository/questions/batch/create/',
        method: 'post',
        data
    })
}
// 统计
export function getSummary(params) { // 培训数据统计
    return request({
        url: '/api/training-exam/summary/' ,
        method: 'get',
        params
    })
}
export function monthlyStat(params) { // 近一年参与培训人数及通过考核人数趋势图
    return request({
        url: '/api/training-exam/monthly-stat/' ,
        method: 'get',
        params
    })
}
export function usersStat(params) { // 人员统计信息
    return request({
        url: '/api/training_users_stat/' ,
        method: 'get',
        params
    })
}
export function getTop10(params) { // 人员统计信息
    return request({
        url: '/api/training-exam/top10/' ,
        method: 'get',
        params
    })
}
export function getUserTrainingDetail(params) { // 用户培训统计
    return request({
        url: '/api/user/training/detail/' ,
        method: 'get',
        params
    })
}
export function getUserExamDetail(params) { // 用户考试统计
    return request({
        url: '/api/user/exam/detail/' ,
        method: 'get',
        params
    })
}









